import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { Settings } from '../settings/settings.service';
import { RESTService } from './services/rest.service';
import { MaterialuiModule } from './themes/modules/materialui.module';
import { ContentComponent } from './components/content/content.component';
import { GlobalErrorHandler } from './interceptor/globalErrorHandler';
import { ServerErrorInterceptor } from './interceptor/serverErrorInterceptor';
import { JwtInterceptor } from './interceptor/jwtInterceptor';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { customPaginatorIntl } from './services/customPaginatorIntl.service';
import { SharedModule } from "../shared/shared.module";
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ProgressBarService } from './services/progress-bar.service';
import { SpinnerService } from './services/spinner.service';
import { NavigationService } from './services/navigation.service';
import { SidebarService } from './services/sidebar.service';
import { AuthService } from './services/auth.service';
import { JWTService } from './services/jwt.service';
import { RightService } from './services/right.service';
import { StorageService } from './services/storage.service';
import { CompanyService } from './services/company.service';
import { UserService } from './services/user.service';
import { UserRoleService } from './services/userRole.service';

@NgModule({
    declarations: [
        SidebarComponent,
        ContentComponent,
        ToolbarComponent,
        SpinnerComponent,
        ProgressBarComponent,
    ],
    imports: [
      CommonModule,
      RouterModule,
      HttpClientModule,
      SharedModule
    ],
    exports: [
        // Modules
        CommonModule,
        RouterModule,
        HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        // Components
        SidebarComponent,
        ContentComponent,
        ToolbarComponent,
        SpinnerComponent,
        ProgressBarComponent,
    ],
    providers: [
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
        { provide: MatPaginatorIntl, useValue: customPaginatorIntl() },
        Settings,
        // Services
        StorageService,
        AuthService,
        JWTService,
        RightService,
        RESTService,
        ProgressBarService,
        SpinnerService,
        NavigationService,
        SidebarService,
        UserService,
        UserRoleService,
    ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(`${parentModule.constructor.name} has already been loaded.`);
    }
  }
}
